import { Loader2 } from 'lucide-react'
import { cn } from '@/utils/misc.tsx'

interface LoadingSpinnerProps {
	size?: 'sm' | 'md' | 'lg'
	className?: string
	/** If true, wraps spinner in a centered container */
	fullPage?: boolean
}

const sizeClasses = {
	sm: 'h-4 w-4',
	md: 'h-8 w-8',
	lg: 'h-12 w-12',
}

export function LoadingSpinner({
	size = 'md',
	className,
	fullPage = false,
}: LoadingSpinnerProps) {
	const spinner = (
		<Loader2
			className={cn(
				'animate-spin text-muted-foreground',
				sizeClasses[size],
				className,
			)}
		/>
	)

	if (fullPage) {
		return (
			<div className="flex items-center justify-center min-h-[400px]">
				{spinner}
			</div>
		)
	}

	return spinner
}
